export default __webpack_public_path__ + "d68873f435f4c3e863bd815f5a42e496.jpg";